import { jsx as _jsx } from "react/jsx-runtime";
import { getItemImages, getArchivedItemImages, archiveItemImage, restoreItemImage } from '../../api/item-images';
import { getLevelItems } from '../../api/items';
import EntityArtManager from '../EntityArtManager/EntityArtManager';
const linkage = {
    strategy: 'parallel',
    load: getLevelItems,
    describeLinks: (img, items) => {
        const linked = items.filter(it => it.imageId === img.id);
        const linkCount = linked.length;
        let badgeText = '';
        if (linkCount > 0) {
            const firstName = linked[0].name;
            badgeText = linkCount === 1 ? firstName : `${firstName} +${linkCount - 1}`;
        }
        return {
            count: linkCount,
            badgeText,
            badgeTitle: `${linkCount} linked item${linkCount !== 1 ? 's' : ''}`,
        };
    },
};
const ItemsArt = ({ levelId, refreshTrigger }) => (_jsx(EntityArtManager, { levelId: levelId, refreshTrigger: refreshTrigger, title: "Item Images", containerClassName: "events-art-container", listImages: getItemImages, listArchivedImages: getArchivedItemImages, archiveImage: archiveItemImage, restoreImage: restoreItemImage, linkage: linkage }));
export default ItemsArt;
